// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".extension-courses__main-container {\n  width: 100vw;\n  overflow: hidden;\n}", "",{"version":3,"sources":["webpack://./src/componets/pages/extensionCourses/extensionCourses.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EAEA,gBAAA;AAAJ","sourcesContent":[".extension-courses__main-container{ \r\n    width: 100vw;\r\n\r\n    overflow: hidden;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
